import { ReactNode } from 'react'

import { AvailableModules } from 'generated/featureDefinitions'
import {
  GetModuleAvailabilitiesDocument,
  TrainingsDevLmsFeatureFlagDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

export const LMSModuleAvailabilityWall: React.FC<{
  children: ReactNode
  showWhenEnabled?: boolean
}> = ({ children, showWhenEnabled = true }) => {
  const { company } = useCurrentSession()

  // For trainings_lms, check both module availability and dev feature flag
  const { data: featureFlagData } = useQuery(TrainingsDevLmsFeatureFlagDocument, {
    variables: { companyId: company.id },
  })

  const hasLMSDevFeatureFlag = Boolean(
    featureFlagData?.features?.featuresConnection?.nodes?.find(
      (n) => n.name === 'dev_training_lms' && n.enabled === true
    )
  )

  const { data: moduleData } = useQuery(GetModuleAvailabilitiesDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      ids: [AvailableModules.lms],
      companyId: company.id,
    },
  })

  const moduleAvailabilities = moduleData?.companies.moduleAvailabilities ?? []
  const hasLMSModule = isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.lms)

  const hasFeature = hasLMSModule || hasLMSDevFeatureFlag
  const shouldRender = showWhenEnabled === hasFeature

  if (shouldRender) {
    return <>{children}</>
  } else {
    return <></>
  }
}
